<template>
    <div id="clients_page" class="container-fluid">
        <router-link :to="{ path: '/clients/create' }" v-if="$store.getters.getAuthUser.original.user_type_id < 2" class="btn btn-secondary main-button pull-right">+ Add New Client</router-link>

        <v-client-table :data="tableData" :columns="columns" :options="options" @pagination="updateTooltips" @filter="updateTooltips" @sorted="updateTooltips">
            <div slot="sources" slot-scope="props" class="sources">
                <img v-for="(accounts, data_source_name) in data_connection_accounts[props.row.id]" :title="createTooltip(props.row.id, data_source_name)" :src="$store.state.app_url + '/images/data_sources/' + accounts[0].abbreviation + '.png'">
            </div>

            <div slot="actions" slot-scope="props" class="text-right">
                <router-link :to="{ path: `reports/client/${props.row.id}` }" class="btn btn-info reverse">Reports</router-link>
                <button class="btn btn-info reverse">Archive</button>
                <template v-if="$store.getters.getAuthUser.original.user_type_id < 2">
                    <router-link :to="{ path: `clients/edit/${props.row.id}` }" class="btn btn-info reverse">Admin</router-link>
                    <button @click="remove(props.row.id)" class="btn btn-danger reverse btn-icon">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                </template>
            </div>
        </v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                data_connection_accounts: {},

                columns: ['name', 'sources', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        name:    'Client Name',
                        sources: 'Data Sources',
                        actions: ''
                    },
                    sortable: ['name'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} clients|{count} clients|One client',
                        filter: '',
                        filterPlaceholder: 'Search clients...',
                        noResults: 'No matching clients'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/clients'),
                    axios.get('/api/data-connections/clients')
                ]).then(axios.spread((clients, dataConnectionAccounts) => {
                    this.tableData                = clients.data;
                    this.data_connection_accounts = dataConnectionAccounts.data.data;

                    this.updateTooltips();
                }));
            },

            createTooltip(clientId, dataSourceName) {
                let tooltip = `<table style="font-size:1.2rem" class="table table-borderless table-sm table-tooltip"><thead><tr><td>Source Name</td><td>Account Name</td></tr></thead><tbody>`;

                _.each(this.data_connection_accounts[clientId][dataSourceName], account => {
                    tooltip += `<tr><td>${account.name_given_by_user}</td><td>${account.primary_name_in_source || ''} (${account.primary_account_id || ''})</td></tr>`;
                });

                tooltip += '</tbody></table>';

                return tooltip;
            },

            updateTooltips() {
                setTimeout(() => {
                    $('#clients_page').find('.sources img').each(function() {
                        if ($(this).hasClass('tooltipstered')) {
                            $(this).tooltipster('destroy');
                        }
                    });

                    $('#clients_page').find('.sources img').tooltipster({
                        contentAsHTML:     true,
                        animation:         false,
                        animationDuration: false,
                        interactive:       true,
                        side:              'bottom'
                    });
                }, 0);
            },

            remove(clientId) {
                this.confirmation(this.messages.WARNING_CLIENT_DELETE, () => {
                    axios.delete(`/api/clients/${clientId}`).then(response => {
                        this.fetchServerData();

                        this.$notify({
                            type: 'success',
                            text: this.messages.CLIENT_DELETED
                        });
                    });
                });
            }
        }
    }
</script>

<style lang="scss">
    #clients_page {
        .fa-trash-o {
            font-size: 1.4rem;
            padding: .1rem;
        }

        .sources {
            img {
                max-height: 2.6rem;
            }
        }
    }
</style>
